/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ButtonSwitch extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.state = {
      url: (this.props.url || null),
      method: (this.props.method || 'get'),
      status: (typeof this.props.status === 'boolean') ? this.props.status : false,
      payloadOn: (this.props.on || {}),
      payloadOff: (this.props.off || {}),
      payload: {},
      callback: (this.props.callback || null),
      failback: (this.props.failback || null),
      submitted: false,
    };

    this.onClick = this.onClick.bind(this);
    this.request = this.request.bind(this);
  }

  /**
   * @param {object} nextProps
   */
  componentDidUpdate(nextProps) {
    if (nextProps.status !== this.state.status) {
      this.setState({
        status: nextProps.status,
      });
    }
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   *
   */
  request() {
    if (this.state.url) {
      this.setState({
        submitted: true,
      }, () => {
        Helpers.httpRequest(
          this.state.url,
          this.state.method,
          JSON.stringify(this.state.payload),
          // callback
          (response) => {
            if (this.state.callback) {
              this.state.callback(response);
            }

            this.setState({
              submitted: false,
            });
          },
          // failback
          (error) => {
            if (this.state.failback) {
              this.state.failback(error);
            }

            this.setState({
              submitted: false,
            });
          },
        );
      });
    }
  }

  /**
   * @param {Event} event
   */
  onClick(event, status) {
    this.setState((prevState) => ({
      payload: (status === 'on') ? prevState.payloadOn : prevState.payloadOff,
    }), () => {
      this.request();
    });

    event.preventDefault();
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        {(this.state.submitted)
          ? (<button disabled className="btn btn-light" type="button">Loading...</button>)
          : (
            <div className="btn-group">
              <button disabled={this.state.submitted} type="button" onClick={(e) => this.onClick(e, 'off')} className={`btn btn-rounded ${(this.state.status === false) ? 'btn-danger' : 'btn-light'}`}>OFF</button>
              <button disabled={this.state.submitted} type="button" onClick={(e) => this.onClick(e, 'on')} className={`btn btn-rounded ${(this.state.status === true) ? 'btn-success' : 'btn-light'}`}>ON</button>
            </div>
          )}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ButtonSwitch.propTypes = {
  url: PropTypes.string,
  method: PropTypes.string,
  status: PropTypes.bool,
  on: PropTypes.object,
  off: PropTypes.object,
  callback: PropTypes.func,
  failback: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ButtonSwitch;
